import './App.css';
import "../assets/css/app.css";
import { Router } from '../routes';
import { LanguageProvider } from '../components/contexts/LanguageContext'; 

function App() {
  return (
    <LanguageProvider>
      <div className="app">
        <Router />
      </div>
    </LanguageProvider>
  );
}

export default App;
